import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { addNewBusinessType, addPractice, addPracticeContact, addPracticeOtherDetails, addPracticeProfDetails, addProf, addProfContact, addProfOtherDetails, addProfProfDetails, addSupplier, addSupplierContact, addSupplierOtherDetails, addSupplierProfDetails, businessTypes, practiceAddresses, professinalAddresses, supplierAddresses } from '../queries/businessTypes.query';
import { Subject } from 'rxjs';
import { ToastService } from 'src/app/core/toast.service';

@Injectable()
export class BusinessTyesService {
  private subject = new Subject<any>();
  data = this.subject.asObservable();
  //mydata = this.subject.asObservable();
  constructor(private apollo: Apollo,private toast: ToastService) { }


  getBusinessTYpes(type : string): Observable<any> {
    console.log(type)
    return this.apollo.use("external").subscribe({
      query: businessTypes,
      variables: {type}
    }).pipe(pluck('data', 'directory_business_types'));
  }

  getOthersTypes(type : string): Observable<any> {
    console.log(type)
    return this.apollo.use("external").subscribe({
      query: businessTypes,
      variables: {type}
    }).pipe(pluck('data', 'directory_business_types'));
  }


  updatedDataSelection(data){
    console.log('Updated Data--->', data)
    this.subject.next(data);
  }

  // updatedData(mydata){
  //   this.subject.next(mydata);
  // }




  async updateProf(id,profObj):Promise<any>{
    console.log(profObj)
    console.log(id)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addProf,
      variables: {id,profObj}
    }).pipe(pluck('data', 'update_dental_professionals_by_pk')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }

  async updateSupplier(id, supplierObj):Promise<any>{
    //console.log('ID and SUplierOBj',id,supplierObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addSupplier,
      variables: {id,supplierObj}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }


  async updatePractice(id,practiceObj):Promise<any>{
    console.log(practiceObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addPractice,
      variables: {id,practiceObj}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }


  async updateProfContact(id,contactProfObj):Promise<any>{
    console.log(contactProfObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addProfContact,
      variables: {id,contactProfObj}
    }).pipe(pluck('data', 'update_dental_professionals')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }

  async updateSupplierCon(id, contactSupplierObj):Promise<any>{
    console.log("COntent info step 4--->",id, contactSupplierObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addSupplierContact,
      variables: {id,contactSupplierObj}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }


  async updatePracticeContact(id,contactPracticeObj):Promise<any>{
    console.log(contactPracticeObj)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addPracticeContact,
      variables: {id,contactPracticeObj}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }


  async updateProfProfData(id,profProfDetails):Promise<any>{
    console.log(profProfDetails)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addProfProfDetails,
      variables: {id,profProfDetails}
    }).pipe(pluck('data', 'update_dental_professionals')).toPromise();
    
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }

  async updateSupplierProfData(id, profSupplierDetails):Promise<any>{
    console.log('Step ---------->4',id, profSupplierDetails)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addSupplierProfDetails,
      variables: {id,profSupplierDetails}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }


  async updatePracticeProfData(id,profPracticeDetails):Promise<any>{
    console.log(profPracticeDetails)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addPracticeProfDetails,
      variables: {id,profPracticeDetails}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
    //  this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }


  async updateProfOtherData(id,profBankDetails):Promise<any>{
    console.log(profBankDetails)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addProfOtherDetails,
      variables: {id,profBankDetails}
    }).pipe(pluck('data', 'update_dental_professionals')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }

  async updateSupplierOtherData(id, supplierBankDetails):Promise<any>{
    console.log(supplierBankDetails)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addSupplierOtherDetails,
      variables: {id,supplierBankDetails}
    }).pipe(pluck('data', 'update_dental_suppliers')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update');
            return false
           }
    
  }


  async updatePracticeOtherData(id,practiceBankDetails):Promise<any>{
    console.log(id,practiceBankDetails)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: addPracticeOtherDetails,
      variables: {id,practiceBankDetails}
    }).pipe(pluck('data', 'update_dental_practices')).toPromise();
     this.toast.openSnackBar(
          'Your Details Submitted SuccessFully'
        );
        return true
    }catch (err) {
            console.log(err);
            this.toast.openSnackBar('You Failed To update ');
            return false
           }
    
  }

  // updateProfileImage(id,updateProfile){ 
  //   //console.log(id)
  //   //const updateObj = {updateObj:statusData}
  //   console.log(updateProfile)
  //     return  this.apollo.use("external").mutate({
  //       mutation: updateProfileImage,
  //       variables: {id,updateProfile}
  //     }).pipe(pluck('data', 'update_directory_gallery_posts'));
  
      
  
  //   }

  addNewProfession(favObj){
    console.log(favObj)
  
    
      
    return this.apollo.use("external").mutate({
      mutation: addNewBusinessType,
      variables: {favObj}
    }).pipe(pluck('data', 'insert_directory_categories_one'))

    
    

  }


  async defaultAddress(detaultAddress){

    console.log(detaultAddress)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: supplierAddresses,
      variables: {detaultAddress}
    }).pipe(pluck('data', 'insert_dental_supplier_addresses_one')).toPromise();
    //  this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
        return true
    }catch (err) {
            console.log(err);
            //this.toast.openSnackBar('You Failed To update ');
            return false
           }

  }

  async defaultAddressPractice(detaultAddress){

    console.log(detaultAddress)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: practiceAddresses,
      variables: {detaultAddress}
    }).pipe(pluck('data', 'insert_dental_practice_addresses_one')).toPromise();
    //  this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
        return true
    }catch (err) {
            console.log(err);
            //this.toast.openSnackBar('You Failed To update ');
            return false
           }

  }

  async defaultAddressProfessional(detaultAddress){

    console.log(detaultAddress)
  
    try{
      
     await this.apollo.use("external").mutate({
      mutation: professinalAddresses,
      variables: {detaultAddress}
    }).pipe(pluck('data', 'insert_dental_professional_addresses_one')).toPromise();
    //  this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
        return true
    }catch (err) {
            console.log(err);
            //this.toast.openSnackBar('You Failed To update ');
            return false
           }

  }


}
